<template>
    <div class="card mx-4 has-border-radius">
          <div class="card-image">
            <figure class="image">
              <picture>
                <source loading="lazy" width="320" height="200" :srcset="cardInfo.imageVar[1]">
                <img loading="lazy" width="320" height="200"
                :src="cardInfo.imageVar[0]" :alt="cardInfo.title">
            </picture>
            </figure>
          </div>
          <div class="card-content has-min-height">
            <div class="media">
              <div class="media-content">
                <h2 class="title is-4">{{cardInfo.altTitle}}</h2>
                <div class="content">
                  <p>
                    <strong>Validity - {{cardInfo.validity}}</strong>
                    <br>
                  </p>
                  <p v-for="description in cardInfo.description" :key="description">
                      {{description}}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <router-link tag="a" :to="cardInfo.routeLink" class="card-footer-item"
              >Know More</router-link
            >
            <router-link
              tag="a"
              v-if="!cardPage"
              :to="`/apply-cscs-card?t=${cardTypeId}`"
              class="card-footer-item is-blue custom-bottom-radius"
            >
              Apply Now
            </router-link>
          </footer>
        </div>
</template>

<script>
import { cardTypes } from '@/assets/data';

export default {
  data: () => ({
    cardTypes,
  }),
  props: {
    cardTypeId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cardInfo() {
      return this.cardTypes.find(({ id }) => id === Number(this.cardTypeId));
    },
  },
};
</script>

<style scoped>
  .has-border-radius {
    border-radius: 0.5em;
  }
  .custom-bottom-radius {
    border-bottom-right-radius: 0.5em;
  }
  .mx-4 {
    margin: 0.5em 1em;
  }
  @media (min-width: 1024.01px) {
    .has-min-height {
    min-height: 15.5em;
  }
  .has-min-second-row {
    min-height: 14em;
  }
  .has-min-third-row {
    min-height: 16em;
  }
  .has-min-fourth-row {
    min-height: 19em;
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .has-min-height {
    min-height: 20em;
  }
  .has-min-second-row {
    min-height: 18em;
  }
  .has-min-third-row {
    min-height: 21em;
  }
  .has-min-fourth-row {
    min-height: 25em;
  }
}
</style>
